export default __webpack_public_path__ + "assets/models/1ba84fa7950c84ae12c60ca121105c4a.glb";